// extracted by mini-css-extract-plugin
export var table = "_yj-0";